import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";
import { executeRerunFromCmm } from "../../cmmOrder/utils/executeRerunFromCmm";
import { executeRerunFromOncoEmr } from "../../cmmOrder/utils/executeRerunFromOncoEmr";
import { PRIMARY_CARE_ORG_ID } from "../constants/primaryCareConstants";

export const handleOpenRerunModal = (
  orderId: string,
  type: string,
  tableData: AestraPrimaryCareTable[],
  setRerunOrderData: (data: any) => void,
  setSelectedOrderIdForRerun: (orderId: string) => void,
  setRerunType: (type: "onco-emr" | "cmm" | "") => void,
  setOpenRerunModal: (open: boolean) => void,
) => {
  const order = tableData.find((row) => row.identifier === orderId);
  if (order) {
    setRerunOrderData({
      patientMrn: order.patient_mrn,
      drugName: order.drug_name_onco_emr,
      identifier: order.identifier,
    });
  }
  setSelectedOrderIdForRerun(orderId);
  setRerunType(type as "onco-emr" | "cmm");
  setOpenRerunModal(true);
};

export const handleConfirmRerun = async (
  selectedOrderIdForRerun: string | null,
  rerunType: "onco-emr" | "cmm" | "",
  onSuccess: () => void,
  closeRerunModal: () => void,
) => {
  if (!selectedOrderIdForRerun || !rerunType) return;

  if (rerunType === "onco-emr") {
    await executeRerunFromOncoEmr(
      selectedOrderIdForRerun,
      onSuccess,
      PRIMARY_CARE_ORG_ID,
    );
  } else if (rerunType === "cmm") {
    await executeRerunFromCmm(
      selectedOrderIdForRerun,
      onSuccess,
      PRIMARY_CARE_ORG_ID,
    );
  }
  closeRerunModal();
};
